/**
 * Elios — Paid shipping A/B test
 *
 * Runs ONLY on these product pages:
 *   /products/rasoir-elios®-copie
 *   /products/rasoir-5-en-1-elios®-copy
 *
 * AND only when this attribute is set to "true" (IntelliGems variant):
 *   document.body.setAttribute('data-elios-paid-shipping-test', 'true')
 *
 * When active:
 *   - hides "Livraison gratuite" trust badges (PDP grid + footer icons)
 *   - reflows the remaining 3 badges into an even layout
 *   - replaces remaining free-shipping copy with €3.99 paid shipping
 *   - keeps the French Days countdown banner on free gifts (no delivery copy)
 */
(function () {
  'use strict';

  if (window.__eliosPaidShippingABTestInit) return;
  window.__eliosPaidShippingABTestInit = true;

  var BODY_ATTR = 'data-elios-paid-shipping-test';
  var ACTIVE_CLASS = 'elios-paid-shipping-active';
  var HIDE_CLASS = 'elios-paid-shipping-hide';
  var TRUST_CLASS = 'elios-paid-shipping-trust';
  var ALLOWED_PRODUCT_HANDLES = ['rasoir-elios-copie', 'rasoir-5-en-1-elios-copy'];
  var SHIPPING_AMOUNT = 3.99;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, IFRAME: 1 };
  var replacing = false;
  var debounceTimer = null;
  var pollTimer = null;

  var TITLE_SELECTORS = [
    '.feature-title',
    '.text-with-icons__text-wrapper p.h4',
    '.text-with-icons__text-wrapper .h4',
    '.free-shipping-bar p'
  ].join(', ');

  function normalizeHandle(value) {
    if (!value) return '';
    try {
      value = decodeURIComponent(String(value));
    } catch (e) {}
    return value
      .toLowerCase()
      .replace(/^\/+|\/+$/g, '')
      .replace(/®/g, '')
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function getCurrentProductHandle() {
    try {
      var path = window.location.pathname || '';
      var match = path.match(/\/products\/([^/?#]+)/i);
      if (match && match[1]) return normalizeHandle(match[1]);
    } catch (e) {}

    var meta = document.querySelector('meta[property="og:url"], link[rel="canonical"]');
    if (meta) {
      var href = meta.getAttribute('content') || meta.getAttribute('href') || '';
      var matchMeta = href.match(/\/products\/([^/?#]+)/i);
      if (matchMeta && matchMeta[1]) return normalizeHandle(matchMeta[1]);
    }

    return '';
  }

  function isAllowedProductPage() {
    var handle = getCurrentProductHandle();
    if (!handle) return false;

    for (var i = 0; i < ALLOWED_PRODUCT_HANDLES.length; i++) {
      if (handle === ALLOWED_PRODUCT_HANDLES[i]) return true;
    }

    return false;
  }

  function isFreeShippingBadgeText(text) {
    var value = String(text || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!value) return false;

    return /livraison gratuite|livraison offerte|free shipping|free delivery|frais de livraison/i.test(
      value
    );
  }

  function markHidden(el) {
    if (!el) return;
    el.classList.add(HIDE_CLASS);
    el.setAttribute('aria-hidden', 'true');
  }

  function unmarkHidden(el) {
    if (!el) return;
    el.classList.remove(HIDE_CLASS);
    el.removeAttribute('aria-hidden');
  }

  function clearFreeShippingBadges() {
    document.querySelectorAll('.' + HIDE_CLASS).forEach(unmarkHidden);
    document.querySelectorAll('.' + TRUST_CLASS).forEach(function (el) {
      el.classList.remove(TRUST_CLASS);
    });

    if (document.body) {
      document.body.classList.remove(ACTIVE_CLASS);
    }
  }

  function hideFreeShippingBadges() {
    if (!document.body) return;

    document.body.classList.add(ACTIVE_CLASS);

    document.querySelectorAll('.feature-item').forEach(function (item) {
      var title = item.querySelector('.feature-title');
      var icon = item.querySelector('img[alt="Free Delivery Icon"]');
      if (!icon && (!title || !isFreeShippingBadgeText(title.textContent))) return;

      markHidden(item);

      var container = item.closest('.features-container') || item.closest('.features-wrapper');
      if (container) container.classList.add(TRUST_CLASS);
    });

    document.querySelectorAll('.text-with-icons__item').forEach(function (item) {
      var heading = item.querySelector(
        '.text-with-icons__text-wrapper .h4, .text-with-icons__text-wrapper .h5, .text-with-icons__text-wrapper p.h4'
      );
      var isKnownBlock = item.id === 'block-text-with-icons-free-shipping';
      var isFreeHeading = heading && isFreeShippingBadgeText(heading.textContent);
      if (!isKnownBlock && !isFreeHeading) return;

      markHidden(item);

      var section = item.closest('.shopify-section--text-with-icons');
      var list = item.closest('.text-with-icons__list');
      if (section) section.classList.add(TRUST_CLASS);
      if (list) list.classList.add(TRUST_CLASS);

      var items = item.parentElement
        ? item.parentElement.querySelectorAll('.text-with-icons__item')
        : [];
      var dots = section ? section.querySelectorAll('page-dots button') : [];
      for (var i = 0; i < items.length; i++) {
        if (items[i] === item && dots[i]) {
          markHidden(dots[i]);
        }
      }
    });
  }

  function getBodyAttrValue() {
    var body = document.body;
    var html = document.documentElement;
    if (!body) return null;

    var value = body.getAttribute(BODY_ATTR);
    if (value == null && html) {
      value = html.getAttribute(BODY_ATTR);
    }

    return value;
  }

  function isAttrEnabled() {
    return String(getBodyAttrValue()).toLowerCase() === 'true';
  }

  function shouldRun() {
    if (!isAllowedProductPage()) return false;
    return isAttrEnabled();
  }

  function formatShippingPrice() {
    var locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'fr';
    var currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(SHIPPING_AMOUNT);
    } catch (e) {
      return '€3.99';
    }
  }

  function isEnglishPage() {
    var lang = (document.documentElement.lang || (window.Shopify && Shopify.locale) || 'fr').toLowerCase();
    return lang.indexOf('en') === 0;
  }

  function getPaidShippingLabel(price) {
    return isEnglishPage() ? 'Delivery ' + price : 'Frais de livraison ' + price;
  }

  function getInlineFrenchReplacement(price) {
    return 'des frais de livraison de ' + price;
  }

  function applyCase(text, replacement) {
    if (!text) return replacement;
    if (text === text.toUpperCase()) return replacement.toUpperCase();
    if (text[0] === text[0].toUpperCase()) {
      return replacement.charAt(0).toUpperCase() + replacement.slice(1);
    }
    return replacement.toLowerCase();
  }

  function replaceFreeShippingText(text, price, paidLabel, inlineOnly) {
    if (!text) return text;

    var normalized = text.replace(/\s+/g, ' ').trim();
    var inlineFr = getInlineFrenchReplacement(price);
    var englishCharge = 'apply a delivery charge of ' + price;
    var paidLabelUpper = paidLabel.toUpperCase();

    if (!inlineOnly) {
      var exactMap = {
        'Livraison gratuite': paidLabel,
        'LIVRAISON GRATUITE': paidLabelUpper,
        'Livraison Gratuite': paidLabel,
        'Free delivery': paidLabel,
        'FREE DELIVERY': paidLabelUpper,
        'Free shipping': isEnglishPage() ? 'Shipping ' + price : paidLabel,
        'Livraison offerte': paidLabel
      };

      if (exactMap[normalized]) {
        return exactMap[normalized];
      }
    }

    if (!/gratuit|offert|free shipping|free delivery|offer free delivery/i.test(text)) {
      return text;
    }

    var result = text;

    [
      [/la livraison gratuite/gi, inlineFr],
      [/LIVRAISON GRATUITE[^!]*!/gi, paidLabelUpper + ' !'],
      [/LIVRAISON GRATUITE/gi, paidLabelUpper],
      [/Livraison Gratuite/g, paidLabel],
      [/livraison gratuite/gi, function (match) {
        return applyCase(match, inlineOnly ? inlineFr : paidLabel);
      }],
      [/Livraison offerte dès 30€ d[''\u2019]achat/gi, function (match) {
        return applyCase(match, paidLabel);
      }],
      [/Livraison offerte/gi, function (match) {
        return applyCase(match, paidLabel);
      }],
      [/Livraison Offerte/g, paidLabel],
      [/livré gratuitement/gi, function (match) {
        return applyCase(match, 'livré pour ' + price);
      }],
      [/frais de livraison offerts/gi, inlineFr],
      [/Félicitations ! Vous avez la Livraison Offerte !/g, paidLabel],
      [/offer free delivery/gi, function (match) {
        return applyCase(match, englishCharge);
      }],
      [/FREE DELIVERY/g, paidLabelUpper],
      [/Free delivery/g, paidLabel],
      [/free delivery/gi, function (match) {
        return applyCase(match, paidLabel);
      }],
      [/free shipping/gi, function (match) {
        return applyCase(match, isEnglishPage() ? 'Shipping ' + price : paidLabel);
      }]
    ].forEach(function (rule) {
      result = result.replace(rule[0], rule[1]);
    });

    return result;
  }

  function patchTitleElements(price, paidLabel) {
    document.querySelectorAll(TITLE_SELECTORS).forEach(function (el) {
      if (el.closest('.' + HIDE_CLASS)) return;
      if (isCountdownBanner(el)) return;

      var current = el.textContent.replace(/\s+/g, ' ').trim();
      var updated = replaceFreeShippingText(current, price, paidLabel, false);
      if (updated !== current) {
        el.textContent = updated;
      }
    });
  }

  function walkTextNodes(root, callback) {
    if (!root) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || SKIP_TAGS[parent.tagName]) {
          return NodeFilter.FILTER_REJECT;
        }
        if (!node.nodeValue || !node.nodeValue.trim()) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var node;
    while ((node = walker.nextNode())) {
      callback(node);
    }
  }

  function patchFreeShippingBar(paidLabel) {
    document.querySelectorAll('free-shipping-bar').forEach(function (bar) {
      bar.setAttribute('reached-message', paidLabel);
      bar.setAttribute('unreached-message', paidLabel);
      var message = bar.querySelector('span');
      if (message && message.textContent !== paidLabel) {
        message.textContent = paidLabel;
      }
    });

    document.querySelectorAll('.free-shipping-bar p').forEach(function (node) {
      if (node.textContent !== paidLabel) {
        node.textContent = paidLabel;
      }
    });
  }

  function isCountdownBanner(el) {
    return !!(el && el.closest && el.closest('#bf-countdown-timer'));
  }

  function stripDeliveryFromBannerText(text) {
    if (!text) return text;

    return text
      // EN
      .replace(/\bFREE\s+GIFTS\s*(?:&amp;|[&＆])\s*(?:FREE\s+)?DELIVERY\b/gi, 'FREE GIFTS')
      .replace(/\bGIFTS\s*(?:&amp;|[&＆])\s*(?:FREE\s+)?DELIVERY\b/gi, 'FREE GIFTS')
      .replace(/(?:&amp;|[&＆])\s*(?:FREE\s+)?DELIVERY\b/gi, '')
      .replace(/\b(?:FREE\s+)?DELIVERY\s*(?:€\s*)?3[,.]99(?:\s*€)?/gi, '')
      // FR — exact live copy: "CADEAUX & LIVRAISON OFFERTE"
      .replace(/CADEAUX\s*(?:&amp;|[&＆])\s*LIVRAISON\s+OFFERTE/gi, 'CADEAUX')
      .replace(/(?:&amp;|[&＆])\s*LIVRAISON\s+OFFERTE/gi, '')
      .replace(/\s+LIVRAISON\s+OFFERTE/gi, '')
      .replace(/\s{2,}/g, ' ');
  }

  // Announcement bar: keep free gifts, drop delivery (paid in this variant).
  function restoreCountdownBannerFreeCopy() {
    var banners = document.querySelectorAll('#bf-countdown-timer');
    if (!banners.length) return;

    for (var i = 0; i < banners.length; i++) {
      var banner = banners[i];

      // Prefer HTML rewrite so &amp; / text-node splits both get fixed
      var html = banner.innerHTML;
      var nextHtml = stripDeliveryFromBannerText(html);
      if (nextHtml !== html) {
        banner.innerHTML = nextHtml;
      } else {
        walkTextNodes(banner, function (node) {
          var parent = node.parentElement;
          if (parent && (parent.id === 'bf-time' || parent.closest('.bf-chip'))) return;

          var text = node.nodeValue;
          var updated = stripDeliveryFromBannerText(text);
          if (updated !== text) {
            node.nodeValue = updated;
          }
        });
      }

      banner.setAttribute('data-elios-paid-shipping-banner', 'true');

      var chips = banner.querySelectorAll('.bf-chip');
      for (var c = 0; c < chips.length; c++) {
        chips[c].style.marginLeft = '8px';
      }
    }
  }

  function clearCountdownBannerPaidShipping() {
    var banners = document.querySelectorAll('#bf-countdown-timer');
    for (var i = 0; i < banners.length; i++) {
      banners[i].removeAttribute('data-elios-paid-shipping-banner');
      var chips = banners[i].querySelectorAll('.bf-chip');
      for (var c = 0; c < chips.length; c++) {
        chips[c].style.marginLeft = '';
      }
    }
  }

  function apply() {
    // Banner copy follows the attribute even before product gating.
    if (isAttrEnabled()) {
      restoreCountdownBannerFreeCopy();
    } else {
      clearCountdownBannerPaidShipping();
    }

    if (!shouldRun()) {
      clearFreeShippingBadges();
      return;
    }

    var price = formatShippingPrice();
    var paidLabel = getPaidShippingLabel(price);
    replacing = true;

    try {
      hideFreeShippingBadges();

      walkTextNodes(document.body, function (node) {
        var parent = node.parentElement;
        if (parent && parent.closest('.' + HIDE_CLASS)) return;
        if (isCountdownBanner(parent)) return;

        var updated = replaceFreeShippingText(node.nodeValue, price, paidLabel, true);
        if (updated !== node.nodeValue) {
          node.nodeValue = updated;
        }
      });

      patchTitleElements(price, paidLabel);
      patchFreeShippingBar(paidLabel);
      restoreCountdownBannerFreeCopy();
    } finally {
      replacing = false;
    }
  }

  function scheduleApply() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(apply, 30);
  }

  function startPolling() {
    var elapsed = 0;
    var maxMs = 60000;
    var intervalMs = 400;

    if (pollTimer) return;

    pollTimer = window.setInterval(function () {
      apply();
      elapsed += intervalMs;

      if (elapsed >= maxMs) {
        window.clearInterval(pollTimer);
        pollTimer = null;
      }
    }, intervalMs);
  }

  function init() {
    apply();
    startPolling();

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === BODY_ATTR
        ) {
          scheduleApply();
          return;
        }
      }

      if (replacing || !shouldRun()) return;

      for (var j = 0; j < mutations.length; j++) {
        var next = mutations[j];
        if (next.addedNodes.length || next.type === 'characterData') {
          scheduleApply();
          return;
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [BODY_ATTR]
    });

    if (document.documentElement) {
      new MutationObserver(scheduleApply).observe(document.documentElement, {
        attributes: true,
        attributeFilter: [BODY_ATTR]
      });
    }

    document.addEventListener('cart:change', scheduleApply);
    document.addEventListener('shopify:section:load', scheduleApply);
    window.addEventListener('load', scheduleApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.EliosPaidShippingABTest = {
    apply: apply,
    shouldRun: shouldRun,
    isAllowedProductPage: isAllowedProductPage
  };
})();
